import type { MaskitoOptions } from '@maskito/core';
import { maskitoTransform } from '@maskito/core';

/**
 * Translates Reefer's `maskFormat` string into Maskito's mask, where `#` marks
 * a digit slot and every other character is a literal the mask fills in for the
 * user — `(###) ###-####` displays `5551234567` as `(555) 123-4567`.
 */
export const maskOptionsFromFormat = (format: string): MaskitoOptions => ({
  mask: [...format].map((character) => (character === '#' ? /\d/ : character)),
});

/** Applies a mask to a value the field received rather than one the user typed. */
export const maskValue = (value: string, options: MaskitoOptions | null) =>
  options ? maskitoTransform(value, options) : value;

/**
 * Strips a masked value back to the digits callers care about. A blanket
 * non-digit strip is exact here because every `maskFormat` slot is a digit, so
 * the only non-digits a masked value can hold are the mask's own literals.
 */
export const unmaskValue = (value: string, options: MaskitoOptions | null) =>
  options ? value.replace(/\D/g, '') : value;
